import { FC } from "react";
import Home from "./Home";
import Text from "@src/lib/ui/Text";
import { useUserContextState } from "@src/lib/contexts/UserContext";
import { getTimeOfDay } from "@src/lib/utils/dates";
import OverviewOfYourLocationsWidgets from "@src/features/home/OverviewOfYourLocationsWidgets";
import LocationAssignmentLeaderboardWidget from "./LocationAssignmentLeaderboardWidget";
import ActiveLanguagesWidget from "./ActiveLanguagesWidget";
import MyTrainingCarousel from "./MyTrainingCarousel";
import CheckInsToFacilitateCard from "@src/features/formCompletion/checkIns/CheckInsToFacilitateCard";
import ReleaseHeadline from "./releaseHeadline/ReleaseHeadline";
import IntroducingAgentsHomeCard from "./IntroducingAgentsHomeCard";

const ManagerHome: FC = () => {
  const { user } = useUserContextState();

  return (
    <Home>
      <div className="flex flex-col gap-6">
        {user?.firstName && (
          <Text variant="display">
            Good {getTimeOfDay()}, {user.firstName}
          </Text>
        )}
        <IntroducingAgentsHomeCard />
        <ReleaseHeadline />
        <MyTrainingCarousel />
        <CheckInsToFacilitateCard />
        <OverviewOfYourLocationsWidgets />
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <ActiveLanguagesWidget />
          <LocationAssignmentLeaderboardWidget />
        </div>
      </div>
    </Home>
  );
};

export default ManagerHome;
